export class ComparableModel {
}
